import React from 'react';
import { Song } from '@/types/player';
import { useAuth } from '@/hooks/useAuth';

import { cn } from '@/lib/utils';
import { Lock } from 'lucide-react';
import { User } from '@/types/user';


interface FavoriteSongCardProps {
  song: Song;
  onClick: () => void;
  user: ReturnType<typeof useAuth>['user'];
  isLoading: boolean;
}

const FavoriteSongCard: React.FC<FavoriteSongCardProps> = ({ song, onClick, user, isLoading }) => {
  return (
    <div
      className={cn(
        "cursor-pointer group",
        isLoading && "opacity-50 pointer-events-none"
      )}
      onClick={onClick}
    >
      <div className="flex flex-col items-center">
        <div className="relative aspect-square w-32 h-32 rounded-2xl overflow-hidden mb-4">
          <img 
            key={song.id}
              src={song.capa_url}
              alt={song.descricao}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const fallback = e.currentTarget.nextElementSibling as HTMLElement;
              if (fallback) fallback.style.display = 'flex';
            }}
          />
          <div className="hidden w-full h-full bg-gradient-to-br from-blue-400 to-purple-500 items-center justify-center">
            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            </svg>
          </div>
          {/* Badge/ícone de grátis/premium */}
          {user?.tipo_de_conta !== 'premium' && song.is_free === true && (
            <span className="absolute top-1 left-1 bg-green-500 text-white text-xs font-bold px-2 py-0.5 rounded shadow">Grátis</span>
          )}
          {user?.tipo_de_conta !== 'premium' && song.is_free === false && (
            <span className="absolute top-1 right-1 bg-yellow-400 rounded-full p-1 shadow">
              <Lock className="w-4 h-4 text-white" />
            </span>
          )}
          {/* Bottom gradient for visual effect */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent z-10" />
        </div>
        <h3 className="section-title text-sm max-w-[180px]">
          {song.descricao}
        </h3>
      </div>
    </div>
  );
};

export default FavoriteSongCard; 